module.exports = __webpack_public_path__ + "static/img/59.9b79ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/19/59.jpg
// module id = 720
// module chunks = 0